export const locale = {
    lang: 'fr',
    data: {
      DATE_RANGE: {
        FROM: 'De',
        TO: 'À',
        PERIOD: 'Période',
        CURRENT_MONTH: 'Mois en cours',
        PREVIOUS_MONTH: 'Mois précédent',
        CURRENT_YEAR: 'Année en cours',
        PREVIOUS_YEAR: 'Année précédente',
        FLOATING_MONTH: '30 derniers jours',
        FLOATING_YEAR: '365 derniers jours',
        RESET: 'Réinitialiser au mois en cours',
        CLEAR_FILTER: 'Supprimer le filtre',
        APPLY_FILTER: 'Appliquer le filtre'
      }
    }
  };